import React, { useEffect, useRef } from 'react';
import '../styles/animations.css';

const AnimatedElement = ({ 
  children, 
  animation = 'fade-up', 
  delay = 0,
  threshold = 0.1,
  className = ''
}) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const currentElement = elementRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.remove('hidden');
              entry.target.classList.add(animation);
            }, delay);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: threshold
      }
    );

    if (currentElement) {
      observer.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement);
      }
    };
  }, [animation, delay, threshold]);

  return (
    <div 
      ref={elementRef} 
      className={`hidden ${className}`}
    >
      {children}
    </div>
  );
};

export default AnimatedElement; 